import { Map, fromJS, List } from "immutable";
import companySubscriptionConstants from "../constants/companySubscriptionConstants";

const initialState = Map({
	subscriptions: List(),
	meta: Map(),
	request: false,
	error: null,
	successMessage: "",
});

export default (state = initialState, action) => {
	switch (action.type) {
		case companySubscriptionConstants.COMPANY_SUBSCRIPTION_POPULATE_SUCCESS:
			return state
				.set("subscriptions", fromJS(action.data.result || action.data))
				.set("meta", fromJS(action.data.meta || {}));

		case companySubscriptionConstants.COMPANY_SUBSCRIPTIONS_CREATE_SUCCESS:
			return state
				.set("subscriptions", fromJS(action.data.result || action.data))
				.set("meta", fromJS(action.data.meta || {}))
				.set(
					"successMessage",
					fromJS(action.message || "Subscriptions created")
				);

		case companySubscriptionConstants.COMPANY_SUBSCRIPTION_FAILURE:
			return state.set("error", fromJS(action.error)).set("request", false);

		case companySubscriptionConstants.SET_COMPANY_SUBSCRIPTION_SUCCESS_MESSAGE:
			return state.set("successMessage", fromJS(action.message));

		case companySubscriptionConstants.COMPANY_SUBSCRIPTION_REQUEST_DONE:
			return state.set("request", false);

		case companySubscriptionConstants.COMPANY_SUBSCRIPTIONS_GET_REQUEST:
			return state
				.set("request", true)
				.set("error", null)
				.set("successMessage", "")
				.set("subscriptions", fromJS(action.data.result || action.data))
				.set("meta", fromJS(action.data.meta || {}));

		default:
			return state;
	}
};
